<nz-page-header [nzTitle]="displayTitle"></nz-page-header>
<form nz-form [formGroup]="form" class="single-column-form" *ngIf="form">
	<ng-container *ngFor="let wrapper of formControls">
		<ng-container *ngIf="hasControl(form, wrapper)">
			<ng-container [ngSwitch]="wrapper.element.dataType">
				<app-dynamic-form-input-text *ngSwitchCase="'Text'" [form]="form" [wrapper]="wrapper" [readonly]="isReadOnly(wrapper)"></app-dynamic-form-input-text>
				<app-dynamic-form-input-textarea *ngSwitchCase="'TextArea'" [form]="form" [wrapper]="wrapper"  [readonly]="isReadOnly(wrapper)"></app-dynamic-form-input-textarea>
				<app-dynamic-form-input-number *ngSwitchCase="'Number'" [form]="form" [wrapper]="wrapper"  [readonly]="isReadOnly(wrapper)"></app-dynamic-form-input-number>
				<app-dynamic-form-input-drop-down *ngSwitchCase="'DropDownSingle'" [form]="form" [wrapper]="wrapper"  [readonly]="isReadOnly(wrapper)"></app-dynamic-form-input-drop-down>
				<app-dynamic-form-input-boolean *ngSwitchCase="'Boolean'" [form]="form" [wrapper]="wrapper"  [readonly]="isReadOnly(wrapper)"></app-dynamic-form-input-boolean>
				<app-dynamic-form-input-boolean *ngSwitchCase="'RequiredCheckbox'" [form]="form" [wrapper]="wrapper"  [readonly]="isReadOnly(wrapper)"></app-dynamic-form-input-boolean>
				<app-dynamic-form-input-date *ngSwitchCase="'PastDate'" [form]="form" [wrapper]="wrapper"  [readonly]="isReadOnly(wrapper)"></app-dynamic-form-input-date>
				<app-dynamic-form-input-date *ngSwitchCase="'Date'" [form]="form" [wrapper]="wrapper"  [readonly]="isReadOnly(wrapper)"></app-dynamic-form-input-date>
				<app-dynamic-form-input-date *ngSwitchCase="'FutureDate'" [form]="form" [wrapper]="wrapper"  [readonly]="isReadOnly(wrapper)"></app-dynamic-form-input-date>
				<app-dynamic-form-input-time *ngSwitchCase="'Time'" [form]="form" [wrapper]="wrapper"  [readonly]="isReadOnly(wrapper)"></app-dynamic-form-input-time>
				<app-dynamic-form-input-datetime *ngSwitchCase="'PastDateTime'" [form]="form" [wrapper]="wrapper"  [readonly]="isReadOnly(wrapper)"></app-dynamic-form-input-datetime>
				<app-dynamic-form-input-datetime *ngSwitchCase="'FutureDateTime'" [form]="form" [wrapper]="wrapper"  [readonly]="isReadOnly(wrapper)"></app-dynamic-form-input-datetime>
				<app-dynamic-form-input-file *ngSwitchCase="'File'" [form]="form" [wrapper]="wrapper"  [readonly]="isReadOnly(wrapper)"></app-dynamic-form-input-file>
				<app-dynamic-form-input-password *ngSwitchCase="'Password'" [form]="form" [wrapper]="wrapper"  [readonly]="isReadOnly(wrapper)"></app-dynamic-form-input-password>
				<app-dynamic-form-input-email *ngSwitchCase="'Email'" [form]="form" [wrapper]="wrapper"  [readonly]="isReadOnly(wrapper)"></app-dynamic-form-input-email>
				<app-dynamic-form-input-msisdn *ngSwitchCase="'Msisdn'" [form]="form" [wrapper]="wrapper"  [readonly]="isReadOnly(wrapper)"></app-dynamic-form-input-msisdn>
				<app-dynamic-form-input-drop-down *ngSwitchCase="'SelectFromRecords'" [form]="form" [wrapper]="wrapper"  [readonly]="isReadOnly(wrapper)"></app-dynamic-form-input-drop-down>
				<app-dynamic-form-input-sub-dynamic *ngSwitchCase="'SetOfRecords'" [form]="form" [dynamicForm]="dynamicForm" [wrapper]="wrapper"  [readonly]="isReadOnly(wrapper)" template="table"></app-dynamic-form-input-sub-dynamic>
				<app-dynamic-form-input-hierarchy *ngSwitchCase="'Hierarchy'" [form]="form" [wrapper]="wrapper" [readonly]="isReadOnly(wrapper)"></app-dynamic-form-input-hierarchy>
			</ng-container>
		</ng-container>
	</ng-container>

	<nz-form-item>
		<nz-form-control [nzSpan]="24" class="text-right">
			<button class="me-1" nz-button nzType="default" (click)="doCancel()">Cancel</button>
			<button nz-button nzType="primary" *ngIf="form.valid" (click)="doSave()">Save</button>
			<button
				*ngIf="!form.valid"
				nz-button
				nzType="default"
				nz-tooltip
				[nzTooltipTitle]="titleTemplate"
				(click)="doTouchAllFields(form)" >
				Save
			</button>
		</nz-form-control>
	</nz-form-item>
</form>

<ng-template #titleTemplate let-thing>
	<ul>
		<li *ngFor="let item of getInvalidControlsList(form)">
			<b>{{item.field}}: </b>
			{{item. errors}}
		</li>
	</ul>
</ng-template>
